import {
  styled,
  TextField,
  Button,
  FormControl,
  Paper,
  ListItem,
  ListItemProps,
} from '@mui/material'

export const PhonePrefix = styled(TextField)(({ theme }) => ({
  flexBasis: 35,
  '& .MuiInput-root': {
    minHeight: '48px',
    alignItems: 'flex-end',
  },
  '& .MuiInputBase-input': {
    width: 'auto',
    height: theme.spacing(6),
    padding: 0,
    lineHeight: '24px',
  },
  '& .MuiInput-formControl.Mui-disabled': {
    backgroundColor: 'transparent',
  },
  '& .MuiInput-underline.Mui-disabled': {
    '&:before': {
      borderBottomStyle: 'solid',
    },
  },
}))

PhonePrefix.defaultProps = {
  variant: 'standard',
}

export const PhoneInputWrap = styled('div')(({ theme }) => ({
  width: '100%',
  '& input': {
    height: theme.spacing(6.5),
  },
}))

export const PhoneInput = styled(TextField)(({ theme }) => ({
  width: '100%',
  flexBasis: 'calc(100% - 68px - 35px)',
  minHeight: 'auto',
  position: 'static',
  '& > label': {
    [theme.breakpoints.down(370)]: {
      width: 200,
    },
  },
  '& .MuiInputLabel-shrink + .MuiInput-root .MuiInput-input': {
    paddingTop: theme.spacing(0.5),
    paddingLeft: 0,
  },
  '& .MuiInputLabel-formControl': {
    transform: 'translate(4px, 12px) scale(0.857)',
    transformOrigin: 'top left',
    padding: 0,
  },
  '& .MuiInputLabel-shrink + .Mui-disabled': {
    backgroundColor: 'transparent',
  },
}))

export const CountryFlagButton = styled(Button)(({ theme }) => ({
  flex: '0 0',
  cursor: 'pointer',
  minWidth: theme.spacing(8.5),
  minHeight: theme.spacing(8),
  background: 'none',
  padding: theme.spacing(2, 1, 0, 1.5),
  boxShadow: 'inset -1px -2px 0px -1px #ccc',
  position: 'relative',
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'inset -1px -3px 0px -1px #000',
  },
  '& .MuiButton-label img': {
    fontSize: '1.25em !important',
  },
  '& .MuiSvgIcon-root': {
    color: '#999',
  },
}))

export const SearchFieldFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  '& .MuiTextField-root': {
    margin: theme.spacing(0.5, 1, 1, 1),
    padding: theme.spacing(0),
    minHeight: 'auto',
  },
  '& .MuiInput-root': {
    paddingLeft: theme.spacing(1.5),
  },
  '& .MuiInputBase-input': {
    height: theme.spacing(6),
    boxSizing: 'border-box',
  },
  '& .MuiInput-underline:before': {
    height: '100%',
    border: '1px solid #D9D9D9',
  },
  '& .MuiSvgIcon-root': {
    fill: '#999',
  },
}))

export const StyledPaper = styled(Paper)(({ theme }) => ({
  marginRight: 0,
  maxHeight: theme.spacing(50),
  maxWidth: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  background: '#FFFFFF',
  borderRadius: 0,
  boxShadow: '0 3.5px 14px rgba(0, 0, 0, 0.2)',
  '&::-webkit-scrollbar': {
    width: '0.5em',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    outline: '1px solid #efefef',
    borderRadius: '0.05em',
  },
}))

export const StyledListItem = styled(ListItem)<ListItemProps>(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  padding: theme.spacing(1.5),
  '& .MuiListItemIcon-root': {
    color: '#000',
    minWidth: '1.5em',
    marginRight: theme.spacing(2),
  },
  '& .flag-icon-lg': {
    fontSize: '1.5em',
  },
}))
